module.exports = __webpack_public_path__ + "img/wordlearn.21352af4.png";